export default {
    REQUEST_CATEGORY_LIST: 'CATEGORIES/REQUEST_CATEGORY_LIST',
    RECEIVE_CATEGORY_LIST: 'CATEGORIES/RECEIVE_CATEGORY_LIST',
    HANDLE_CATEGORY_LIST_ERROR: 'CATEGORIES/HANDLE_CATEGORY_LIST_ERROR'
};
